/** Auto-extracted from Idtel.vue — 15 API steps, radio options per ítem. */
export const IDTEL_STEPS_SCHEMA = [
  [
    {
      "var": "Rango_Etario",
      "options": [
        {
          "value": "a",
          "text": "6 - 7 años, 11 meses"
        },
        {
          "value": "b",
          "text": "8 - 9 años, 11 meses"
        }
      ]
    },
    {
      "var": "p1",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "1",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "1",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "1",
          "text": "A"
        },
        {
          "value": "0",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "1",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p10",
      "options": [
        {
          "value": "1",
          "text": "A"
        },
        {
          "value": "0",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "1",
          "text": "LE"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "1",
          "text": "FE"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "1",
          "text": "RE"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "1",
          "text": "PE"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "1",
          "text": "PI"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "1",
          "text": "RE"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "1",
          "text": "BLO"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "1",
          "text": "BO"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "1",
          "text": "LO"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p10",
      "options": [
        {
          "value": "1",
          "text": "TE"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p11",
      "options": [
        {
          "value": "1",
          "text": "LI"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p12",
      "options": [
        {
          "value": "1",
          "text": "LE"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p13",
      "options": [
        {
          "value": "1",
          "text": "TE"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p14",
      "options": [
        {
          "value": "1",
          "text": "PI"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p15",
      "options": [
        {
          "value": "1",
          "text": "FI"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "1",
          "text": "Caballo"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "1",
          "text": "Pantalón"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "1",
          "text": "Pirata"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "1",
          "text": "Cuaderno"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "1",
          "text": "Camisa"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "1",
          "text": "Pelota"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "1",
          "text": "Estuche"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "1",
          "text": "Pizarra"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "1",
          "text": "Carpeta"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p10",
      "options": [
        {
          "value": "1",
          "text": "Sirena"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p11",
      "options": [
        {
          "value": "1",
          "text": "Pintura"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p12",
      "options": [
        {
          "value": "1",
          "text": "Peineta"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p13",
      "options": [
        {
          "value": "1",
          "text": "Serrucho"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p14",
      "options": [
        {
          "value": "1",
          "text": "Escoba"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p15",
      "options": [
        {
          "value": "1",
          "text": "Caracol"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "1",
          "text": "Sol"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "1",
          "text": "Café"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "1",
          "text": "Ratón"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "1",
          "text": "Camisa"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "1",
          "text": "Mueble"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "1",
          "text": "Alcalde"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "1",
          "text": "Palmera"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "1",
          "text": "Elefante"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "1",
          "text": "Película"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p10",
      "options": [
        {
          "value": "1",
          "text": "Plástico"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p11",
      "options": [
        {
          "value": "1",
          "text": "Micrófono"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p12",
      "options": [
        {
          "value": "1",
          "text": "Renacuajo"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p13",
      "options": [
        {
          "value": "1",
          "text": "Computador"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p14",
      "options": [
        {
          "value": "1",
          "text": "Dinosaurio"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p15",
      "options": [
        {
          "value": "1",
          "text": "Ferrocarril"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p10",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p11",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p12",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p13",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p14",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    },
    {
      "var": "p15",
      "options": [
        {
          "value": "1",
          "text": "C"
        },
        {
          "value": "0",
          "text": "I"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "1",
          "text": "Artista"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "1",
          "text": "Pintor"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "1",
          "text": "Relojero"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "1",
          "text": "Zapatero"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "1",
          "text": "Diseñador"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "1",
          "text": "Verdulero"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "1",
          "text": "Carnicero"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "1",
          "text": "Pastelero"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "1",
          "text": "Joyero"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p10",
      "options": [
        {
          "value": "1",
          "text": "Tejedor"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p11",
      "options": [
        {
          "value": "1",
          "text": "Jardinero"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "1",
          "text": "Altísimo"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "1",
          "text": "Flaquísimo"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "1",
          "text": "Carísimo"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "1",
          "text": "Manotas"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "1",
          "text": "Hermosísima"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "1",
          "text": "Esforzadísimo"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "1",
          "text": "Simpatiquísimas"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "1",
          "text": "Inteligentísimas"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "1",
          "text": "Larguísimas"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p10",
      "options": [
        {
          "value": "1",
          "text": "Estudiosísimas"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p11",
      "options": [
        {
          "value": "1",
          "text": "Pesadísimas"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p12",
      "options": [
        {
          "value": "1",
          "text": "Viejísimas"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p13",
      "options": [
        {
          "value": "1",
          "text": "Cariñosísima"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p14",
      "options": [
        {
          "value": "1",
          "text": "Estrictísima"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p15",
      "options": [
        {
          "value": "1",
          "text": "Peligrosísimo"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "1",
          "text": "Rectangular"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "1",
          "text": "Liviana"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "1",
          "text": "Saladas"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "1",
          "text": "Blanda"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "1",
          "text": "Oscuridad"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "1",
          "text": "Hembra"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "1",
          "text": "Cuero"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "1",
          "text": "Buena"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "1",
          "text": "Áspera"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p10",
      "options": [
        {
          "value": "1",
          "text": "Barato"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p11",
      "options": [
        {
          "value": "1",
          "text": "Hunde"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p12",
      "options": [
        {
          "value": "1",
          "text": "Mar"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p13",
      "options": [
        {
          "value": "1",
          "text": "Real, Verdadero"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p14",
      "options": [
        {
          "value": "1",
          "text": "Tersa, Lisa"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "1",
          "text": "medir"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "1",
          "text": "navega"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "1",
          "text": "nadar"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "1",
          "text": "segundos"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "1",
          "text": "aire"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "1",
          "text": "curan, sanan"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "1",
          "text": "acusan"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "1",
          "text": "rodilla"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "1",
          "text": "alas"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "1",
          "text": "cuesco"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "1",
          "text": "años"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "1",
          "text": "días"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "1",
          "text": "tentáculos"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "1",
          "text": "centímetros"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "1",
          "text": "sangre"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "1",
          "text": "hocico"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p10",
      "options": [
        {
          "value": "1",
          "text": "oficinas"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p11",
      "options": [
        {
          "value": "1",
          "text": "palabras"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p12",
      "options": [
        {
          "value": "1",
          "text": "segundos"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p13",
      "options": [
        {
          "value": "1",
          "text": "alcaldes"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p14",
      "options": [
        {
          "value": "1",
          "text": "planetas"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p15",
      "options": [
        {
          "value": "1",
          "text": "actores"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "1",
          "text": "Líquidos"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "1",
          "text": "Meses del año"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "1",
          "text": "Profesiones"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "1",
          "text": "Negocios"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "1",
          "text": "Elementos para cortar"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "1",
          "text": "Festividades"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "1",
          "text": "Dinosaurios"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "1",
          "text": "Enfermedades"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "1",
          "text": "Presidentes de Chile"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p10",
      "options": [
        {
          "value": "1",
          "text": "Océanos"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p11",
      "options": [
        {
          "value": "1",
          "text": "Países europeos/Países"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    },
    {
      "var": "p12",
      "options": [
        {
          "value": "1",
          "text": "Monedas/Dinero"
        },
        {
          "value": "0",
          "text": "Otro"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "1",
          "text": "Alfombra"
        },
        {
          "value": "0",
          "text": "Puerta"
        },
        {
          "value": "00",
          "text": "Ventana"
        },
        {
          "value": "000",
          "text": "Techo"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "0",
          "text": "Teclado"
        },
        {
          "value": "00",
          "text": "Disco Duro"
        },
        {
          "value": "1",
          "text": "Pendrive"
        },
        {
          "value": "000",
          "text": "Pantalla"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "0",
          "text": "Rosa"
        },
        {
          "value": "00",
          "text": "Clavel"
        },
        {
          "value": "1",
          "text": "Pino"
        },
        {
          "value": "000",
          "text": "Margarita"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "0",
          "text": "Tigre"
        },
        {
          "value": "1",
          "text": "Lobo"
        },
        {
          "value": "00",
          "text": "Puma"
        },
        {
          "value": "000",
          "text": "Gato"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "0",
          "text": "Limón"
        },
        {
          "value": "1",
          "text": "Plátano"
        },
        {
          "value": "00",
          "text": "Naranja"
        },
        {
          "value": "000",
          "text": "Pomelo"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "1",
          "text": "Martillo"
        },
        {
          "value": "0",
          "text": "Lápices"
        },
        {
          "value": "00",
          "text": "Regla"
        },
        {
          "value": "000",
          "text": "Plumones"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "0",
          "text": "Flauta"
        },
        {
          "value": "00",
          "text": "Saxofón"
        },
        {
          "value": "1",
          "text": "Timbal"
        },
        {
          "value": "000",
          "text": "Armónica"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "0",
          "text": "Corazón"
        },
        {
          "value": "00",
          "text": "Pulmones"
        },
        {
          "value": "1",
          "text": "Oídos"
        },
        {
          "value": "000",
          "text": "Hígado"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "1",
          "text": "Avión"
        },
        {
          "value": "0",
          "text": "Camión"
        },
        {
          "value": "00",
          "text": "Automóvil"
        },
        {
          "value": "000",
          "text": "Carreta"
        }
      ]
    },
    {
      "var": "p10",
      "options": [
        {
          "value": "0",
          "text": "León"
        },
        {
          "value": "1",
          "text": "Serpiente"
        },
        {
          "value": "00",
          "text": "Caballo"
        },
        {
          "value": "000",
          "text": "Vaca"
        }
      ]
    },
    {
      "var": "p11",
      "options": [
        {
          "value": "0",
          "text": "Queso"
        },
        {
          "value": "00",
          "text": "Yogurt"
        },
        {
          "value": "1",
          "text": "Jugo"
        },
        {
          "value": "000",
          "text": "Crema"
        }
      ]
    },
    {
      "var": "p12",
      "options": [
        {
          "value": "0",
          "text": "Teléfono"
        },
        {
          "value": "00",
          "text": "Computador"
        },
        {
          "value": "1",
          "text": "Imprenta"
        },
        {
          "value": "000",
          "text": "Televisor"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "1",
          "text": "A"
        },
        {
          "value": "0",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "1",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "1",
          "text": "A"
        },
        {
          "value": "0",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "1",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "1",
          "text": "A"
        },
        {
          "value": "0",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "1",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "1",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "1",
          "text": "A"
        },
        {
          "value": "0",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "1",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "1",
          "text": "A"
        },
        {
          "value": "0",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "1",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "1",
          "text": "A"
        },
        {
          "value": "0",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p10",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "1",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    }
  ],
  [
    {
      "var": "p1",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p2",
      "options": [
        {
          "value": "1",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "0",
          "text": "C"
        }
      ]
    },
    {
      "var": "p3",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p4",
      "options": [
        {
          "value": "1",
          "text": "A"
        },
        {
          "value": "0",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p5",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "1",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p6",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "1",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p7",
      "options": [
        {
          "value": "0",
          "text": "A"
        },
        {
          "value": "00",
          "text": "B"
        },
        {
          "value": "1",
          "text": "C"
        }
      ]
    },
    {
      "var": "p8",
      "options": [
        {
          "value": "1",
          "text": "A"
        },
        {
          "value": "0",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p9",
      "options": [
        {
          "value": "1",
          "text": "A"
        },
        {
          "value": "0",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    },
    {
      "var": "p10",
      "options": [
        {
          "value": "1",
          "text": "A"
        },
        {
          "value": "0",
          "text": "B"
        },
        {
          "value": "00",
          "text": "C"
        }
      ]
    }
  ]
];

export const IDTEL_DEFAULT_ANSWER = "1";

/**
 * Ítem no aplicado. RedPsi lo excluye del scoring en vez de autocorregirlo como
 * correcto (ver `feat: soporte para preguntas omitidas en test IDTEL`). No viene
 * en el schema porque no es una alternativa del protocolo: se agrega a mano al
 * final de cada selector en `getIdtelItemOptions`.
 */
export const IDTEL_OMITTED_ANSWER = "om";
